import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
const BackdropTheme = {
    backdrop: {
        light: {
            backgroundColor: withOpacity(Colors.black, Opacities.low),
            backgroundColorMedium: withOpacity(Colors.black, Opacities.medium),
            backgroundColorDarker: 'rgba(0,0,0,.9)',
        },
        dark: {
            backgroundColor: withOpacity(Colors.white, Opacities.low),
            backgroundColorMedium: withOpacity(Colors.white, Opacities.medium),
            backgroundColorDarker: 'rgba(255,255,255,.9)',
        },
    },
};
export default BackdropTheme;
